/** Walapay HighRiskActivities values used in company onboarding. */

export const COMPANY_HIGH_RISK_ACTIVITY_OPTIONS = [
  { value: 'MoneyServices', label: 'Money services (check cashing, gift cards, ATMs, remittances)', kind: 'highRisk' },
  { value: 'LendingBanking', label: 'Lending or banking', kind: 'highRisk' },
  {
    value: 'OperateForeignExchangeVirtualCurrenciesBrokerageOtc',
    label: 'Foreign exchange, virtual currencies brokerage, or OTC',
    kind: 'highRisk',
  },
  { value: 'HoldClientFunds', label: 'Hold client funds (e.g. escrow)', kind: 'highRisk' },
  { value: 'InvestmentServices', label: 'Investment services', kind: 'highRisk' },
  { value: 'SafeDepositBoxRentals', label: 'Safe deposit box rentals', kind: 'highRisk' },
  { value: 'ThirdPartyPaymentProcessing', label: 'Third-party payment processing', kind: 'highRisk' },
  { value: 'AdultEntertainment', label: 'Adult entertainment, content, and services', kind: 'prohibited' },
  { value: 'Gambling', label: 'Gambling', kind: 'prohibited' },
  { value: 'MarijuanaOrRelatedServices', label: 'Marijuana, cannabis, or related services', kind: 'prohibited' },
  { value: 'Pharmaceuticals', label: 'Pharmaceuticals', kind: 'prohibited' },
  { value: 'NicotineTobaccoOrRelatedServices', label: 'Tobacco or nicotine products', kind: 'prohibited' },
  { value: 'PreciousMetalsPreciousStonesJewelry', label: 'Precious metals / gems / jewelry', kind: 'prohibited' },
  { value: 'WeaponsFirearmsAndExplosives', label: 'Weapons / firearms', kind: 'prohibited' },
  { value: 'NoneOfTheAbove', label: 'None of the below', kind: 'none' },
];

const LEGACY_HIGH_RISK_ACTIVITY_VALUES = {
  money_services: 'MoneyServices',
  lending_banking: 'LendingBanking',
  operate_foreign_exchange_virtual_currencies_brokerage_otc: 'OperateForeignExchangeVirtualCurrenciesBrokerageOtc',
  hold_client_funds: 'HoldClientFunds',
  investment_services: 'InvestmentServices',
  safe_deposit_box_rentals: 'SafeDepositBoxRentals',
  third_party_payment_processing: 'ThirdPartyPaymentProcessing',
  adult_entertainment: 'AdultEntertainment',
  gambling: 'Gambling',
  marijuana_or_related_services: 'MarijuanaOrRelatedServices',
  pharmaceuticals: 'Pharmaceuticals',
  nicotine_tobacco_or_related_services: 'NicotineTobaccoOrRelatedServices',
  precious_metals_precious_stones_jewelry: 'PreciousMetalsPreciousStonesJewelry',
  weapons_firearms_and_explosives: 'WeaponsFirearmsAndExplosives',
  none_of_the_above: 'NoneOfTheAbove',
};

export const NONE_OF_THE_ABOVE_ACTIVITY = 'NoneOfTheAbove';

function toHighRiskActivityValue(value) {
  const raw = String(value).trim();
  if (!raw) return '';
  return LEGACY_HIGH_RISK_ACTIVITY_VALUES[raw] || raw;
}

export function normalizeHighRiskActivities(value) {
  let parts = [];
  if (Array.isArray(value)) {
    parts = value.map((item) => String(item).trim()).filter(Boolean);
  } else if (typeof value === 'string' && value.trim()) {
    parts = value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [...new Set(parts.map(toHighRiskActivityValue).filter(Boolean))];
}

export function serializeHighRiskActivities(activities) {
  return normalizeHighRiskActivities(activities).join(',');
}
